var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_2847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.017 2.9396e-08C13.6513 -0.000197754 10.3611 0.997664 7.56256 2.8674C4.764 4.73713 2.58273 7.39475 1.2946 10.5042C0.00646925 13.6136 -0.330667 17.0352 0.325825 20.3362C0.982317 23.6373 2.60295 26.6695 4.98278 29.0495C7.36261 31.4295 10.3947 33.0503 13.6958 33.707C16.9968 34.3636 20.4184 34.0267 23.5279 32.7388C26.6374 31.4508 29.2951 29.2697 31.165 26.4712C33.0349 23.6728 34.033 20.3827 34.033 17.017C34.0274 12.5057 32.2329 8.18073 29.043 4.99065C25.8531 1.80058 21.5283 0.00582176 17.017 2.9396e-08ZM17.017 2.618C20.6502 2.61647 24.1496 3.98927 26.8127 6.46084C29.4758 8.93241 31.1054 12.3198 31.3745 15.9431C31.6436 19.5664 30.5323 23.1574 28.2635 25.9952C25.9948 28.8331 22.7366 30.7078 19.143 31.243V21.179H23.209L23.848 17.053H19.148V14.791C19.148 13.076 19.706 11.555 21.31 11.555H23.886V7.955C22.8188 7.81195 21.7426 7.74711 20.666 7.761C16.886 7.761 14.666 9.761 14.666 14.306V17.052H10.778V21.183H14.671V31.206C11.1036 30.6205 7.88727 28.7135 5.66188 25.8645C3.43648 23.0155 2.36506 19.4332 2.66073 15.8302C2.9564 12.2271 4.59751 8.8674 7.2576 6.4193C9.91769 3.9712 13.4018 2.61412 17.017 2.618Z",
    fill: "#03458F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_2847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.033,
    height: 34.033,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame-1.1f756cb55aef35470ceaf5754c5a032c.svg";
export { ForwardRef as ReactComponent };